import React from "react";
import InputKeyValue from "../InputKeyValue";
import EditNavbar from "../EditNavbar";
import KeyDropdownValue from "../KeyDropdownValue";
import CustomButton from "../CustomButton";
import { SearchIcon, t } from "../../normalizer";

const UserAddressEditForm = (props) => {
  const {
    availableCountries,
    availableStates,
    first_name: firstName,
    last_name: lastName,
    phone,
    email,
    address1,
    city,
    address2,
    country = {},
    state = {},
    main_name: addressName,
    zip_code: zipCode,
    creating,
    errors = {},
    className,
    ...actions
  } = props;

  const [isValid, setIsValid] = React.useState(address1 && zipCode && firstName && lastName && email && phone && addressName);

  const validate = (data) => {
    let errors = {
        address1: undefined,
        zipCode: undefined,
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        phone: undefined,
        addressName: undefined,
    };

    if (!data) {
      setIsValid(false);
      errors = {
        address1: "Por favor preencha o endereço",
        zipCode: "Por favor preencha o código postal",
        firstName: "Por favor preencha o primeiro nome",
        lastName: "Por favor preencha o apelido",
        email: "Por favor preencha o email",
        phone: "Por favor preencha o telemóvel",
        addressName: "Por favor preencha o nome da morada",
      };
      return;
    }

    if (!data.address1) {
      errors.address1 = "Por favor preencha o endereço";
    }
    if (!data.zipCode) {
      errors.zipCode = "Por favor preencha o código postal";
    }
    if (!data.firstName) {
      errors.firstName = "Por favor preencha o primeiro nome";
    }
    if (!data.lastName) {
      errors.lastName = "Por favor preencha o apelido";
    }
    if (!data.email) {
      errors.email = "Por favor preencha o email";
    }
    if (!data.phone) {
      errors.phone = "Por favor preencha o telemóvel";
    }
    if (!data.addressName) {
      errors.addressName = "Por favor preencha o nome da morada";
    }
    if (Object.keys(errors).some(key => errors[key] !== undefined)) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    const { addressName, address1, city, zipCode, firstName, lastName, email, phone } = e.currentTarget;
    validate({
      addressName: addressName.value,
      address1: address1.value,
      city: city.value,
      zipCode: zipCode.value,
      firstName: firstName.value,
      lastName: lastName.value,
      email: email.value,
      phone: phone.value,
    });

  };

  const handleOnSubmit = (event) => {
    event.preventDefault();
    const {
      address1,
      city,
      address2,
      zipCode,
      firstName,
      lastName,
      email,
      phone,
      addressName,
      country,
      state,
    } = event.target;
    const payload = {
      address1: address1.value,
      city: city.value,
      address2: address2.value,
      zipCode: zipCode.value,
      firstName: firstName.value,
      lastName: lastName.value,
      email: email.value,
      phone: phone.value,
      addressName: addressName.value,
      country: country.value,
      state: state.value,
    }
    actions.onEditSubmit(payload);
  };

  return (
    <form id="user-address-edit-form" onChange={handleChange} className={`user-address-form ${className}`} onSubmit={handleOnSubmit}>
      <div className="user-address-form-header">
        <h5 className="user-address-form-name">Edita morada</h5>
        <div className="user-address-form-msg">
          Edite os campos abaixo e guarde as alterações
        </div>
      </div>
      <div className="user-address-form-container">
        <div className="user-address-form-row">
          <div className="user-address-form-column">
            <InputKeyValue
              title="Nome da morada"
              name="addressName"
              defaultValue={addressName}
              error={errors.addressName}
            />
          </div>
          <div className="user-address-form-column3">
          </div>
        </div>

        <div className="user-address-form-row">
          <div className="user-address-form-column">
            <InputKeyValue
              title="Primeiro nome"
              name="firstName"
              error={errors.firstName}
              defaultValue={firstName}
            />
          </div>
          <div className="user-address-form-column">
            <InputKeyValue
              title="Apelido"
              name="lastName"
              error={errors.lastName}
              defaultValue={lastName}
            />
          </div>
          <div className="user-address-form-column">
            <InputKeyValue
              title="Email"
              name="email"
              error={errors.email}
              defaultValue={email}
            />
          </div>
          <div className="user-address-form-column">
            <InputKeyValue
              title="Telemóvel"
              name="phone"
              error={errors.phone}
              defaultValue={phone}
            />
          </div>
        </div>
        <div className="user-address-form-row">
          <div className="user-address-form-column2">
            <InputKeyValue
              leftIcon={<SearchIcon />}
              title="Endereço"
              name="address1"
              error={errors.address1}
              defaultValue={address1}
            />
          </div>
          <div className="user-address-form-column">
            <InputKeyValue
              leftIcon={<SearchIcon />}
              title="Código-Postal"
              name="zipCode"
              error={errors.zipCode}
              defaultValue={zipCode}
            />
          </div>
          <div className="user-address-form-column">
            <InputKeyValue /*disabled*/ title="Localidade" name="city" defaultValue={city} />
          </div>
        </div>
        <div className="user-address-form-row">
          <div className="user-address-form-column2">
            <InputKeyValue
              title="Restante morada"
              name="address2"
              error={errors.address2}
              defaultValue={address2}
            />
          </div>
          <div className="user-address-form-column">
            <KeyDropdownValue
              title="País"
              name="country"
              selectedValue={country}
              options={availableCountries}
              onChange={actions.onCountryChange}
              optionsId="id"
              optionsLabel="name"
              error={errors.country}
              getOptionLabel={(option) => option.name}
            />
          </div>
          <div className="user-address-form-column">
            <KeyDropdownValue
              title="Região"
              name="state"
              selectedValue={state}
              optionsId="id"
              optionsLabel="name"
              error={errors.state}
              options={availableStates}
              onChange={actions.onStateChange}
              getOptionLabel={(option) => option.name}
            />
          </div>
        </div>
      </div>
      <div className="user-address-form-actions">
        <CustomButton
          secondary
          className="mr-3"
          onClick={actions.onEditCancel}
        >
          {t("gamification2026.profile.cancel")}
        </CustomButton>
        <CustomButton 
          type={"submit"} 
          disabled={!isValid}
          form="user-address-edit-form">
          {t("gamification2026.profile.save")}
        </CustomButton>
      </div>
    </form>
  );
};
export default UserAddressEditForm;
